/**
 * Field names, both languages. English names are canonical in the schema;
 * the UI shows whichever the reader switched on.
 */
export interface FieldLabel {
  fa: string;
  en: string;
}

export const fieldLabels = {
  inventory_code: { fa: "کد قطعه", en: "Inventory code" },
  title: { fa: "عنوان", en: "Title" },
  kind: { fa: "نوع قطعه", en: "Kind" },
  metal: { fa: "فلز", en: "Metal" },
  metal_color: { fa: "رنگ فلز", en: "Metal colour" },
  purity_permille: { fa: "عیار (هزارم)", en: "Purity (‰)" },
  gross_weight_g: { fa: "وزن کل", en: "Total weight" },
  net_weight_g: { fa: "وزن فلز", en: "Metal weight" },
  hallmarks: { fa: "انگ / مهر", en: "Hallmarks" },
  maker: { fa: "سازنده", en: "Maker" },
  size_label: { fa: "سایز", en: "Size" },
  year: { fa: "سال ساخت", en: "Year made" },
  ownership_status: { fa: "وضعیت موجودی", en: "Stock status" },
  making_charge_percent: { fa: "اجرت", en: "Making charge" },
  valuation: { fa: "قیمت", en: "Price" },
  currency: { fa: "واحد پول", en: "Currency" },
  condition: { fa: "وضعیت", en: "Condition" },
  condition_notes: { fa: "شرح وضعیت", en: "Condition notes" },
  provenance_text: { fa: "منشأ", en: "Provenance" },
  authenticity_notes: { fa: "یادداشت مدارک", en: "Evidence notes" },
  authenticity_files: { fa: "مدارک / گواهی", en: "Evidence / certificates" },
  notes: { fa: "یادداشت", en: "Notes" },
  stone_type: { fa: "نوع سنگ", en: "Stone" },
  shape: { fa: "تراش / فرم", en: "Shape" },
  count: { fa: "تعداد", en: "Count" },
  carat: { fa: "قیراط", en: "Carat" },
  color: { fa: "رنگ", en: "Colour" },
  clarity: { fa: "شفافیت", en: "Clarity" },
  cut: { fa: "کیفیت تراش", en: "Cut grade" },
  certificate_ref: { fa: "شمارهٔ گواهی", en: "Certificate no." },
  stones: { fa: "سنگ‌ها", en: "Stones" },
  primary_media: { fa: "تصویر اصلی", en: "Primary image" },
  created_at: { fa: "تاریخ ثبت", en: "Created" },
  updated_at: { fa: "آخرین ویرایش", en: "Updated" },
} as const satisfies Record<string, FieldLabel>;
